__turbopack_context__.v({
  "panelLeft": "PanelLeft-module__ME0boq__panelLeft",
});
